import React from 'react'
import {
  IProps as ISupportSpotlight,
  SupportSpotlight,
} from 'marketing-site/src/library/components/SupportSpotlightBRP'
import { ISupportSpotlight as IContentfulSupportSpotlight } from 'marketing-site/@types/generated/contentful'
import { transformSupportSpotlightCard } from 'marketing-site/src/transformers/elements/ContentfulSupportSpotlightCard'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { transformCTALink } from '../elements/ContentfulCTALink'
import { getSnakeCaseFromString } from './ContentfulStatistics'

export const ContentfulSupportSpotlight = (supportSpotlight: IContentfulSupportSpotlight) => {
  return (
    <EntryMarker entry={supportSpotlight}>
      {() => <SupportSpotlight {...transformSupportSpotlight(supportSpotlight)} />}
    </EntryMarker>
  )
}

export function transformSupportSpotlight({
  fields,
}: IContentfulSupportSpotlight): ISupportSpotlight {
  return {
    ...fields,
    featuredCard: transformSupportSpotlightCard(fields.featuredCard),
    interactiveCard1: transformSupportSpotlightCard(fields.interactiveCard1),
    interactiveCard2: transformSupportSpotlightCard(fields.interactiveCard2),
    interactiveCard3: transformSupportSpotlightCard(fields.interactiveCard3),
    interactiveCard1StartPosition:
      fields.interactiveCard1StartPosition &&
      getSnakeCaseFromString(fields.interactiveCard1StartPosition),
    cta: transformCTALink(fields.cta),
  }
}
